import { Component, Inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { IBottomSheetData, SharedConstants, TextType } from '@app/eds';

@Component({
  selector: 'app-bottom-sheet',
  templateUrl: './bottom-sheet.component.html',
  styleUrls: ['./bottom-sheet.component.scss']
})
export class BottomSheetComponent<T> {
  // Provides the title of the bottom sheet
  bottomSheetTitle: string = SharedConstants.EMPTY_STRING;

  // Provides the title font type.
  bottomSheetTitleFontType: TextType;

  // Boolean to specify if close icon is required
  closeIconRequired = true;

  constructor(
    public bottomSheetRef: MatBottomSheetRef<BottomSheetComponent<T>>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: IBottomSheetData<T>
  ) {
    this.bottomSheetTitle = data.bottomSheetTitle;
    this.closeIconRequired = data.closeIconRequired;
    this.bottomSheetTitleFontType = data.titleFontType || 'headline4';
  }

  /**
   * Will close bottom sheet.
   */
  onCloseBottomSheet = () => this.bottomSheetRef.dismiss();
}
